import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/esm/typeof";
var _excluded = ["label", "children", "key", "type"];
import * as React from 'react';
import { ItemGroup } from 'rc-menu9';
import SubMenu from "../SubMenu";
import MenuDivider from "../MenuDivider";
import MenuItem from "../MenuItem";
import { jsx as _jsx } from "react/jsx-runtime";
function convertItemsToNodes(list) {
  return (list || []).map(function (opt, index) {
    if (opt && _typeof(opt) === 'object') {
      var _ref = opt,
        label = _ref.label,
        children = _ref.children,
        key = _ref.key,
        type = _ref.type,
        restProps = _objectWithoutProperties(_ref, _excluded);
      var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);

      // MenuItemGroup & SubMenuItem
      if (children || type === 'group') {
        if (type === 'group') {
          // Group
          return /*#__PURE__*/_jsx(ItemGroup, _objectSpread(_objectSpread({}, restProps), {}, {
            title: label,
            children: convertItemsToNodes(children)
          }), mergedKey);
        }

        // Sub Menu
        return /*#__PURE__*/_jsx(SubMenu, _objectSpread(_objectSpread({}, restProps), {}, {
          title: label,
          children: convertItemsToNodes(children)
        }), mergedKey);
      }

      // MenuItem & Divider
      if (type === 'divider') {
        return /*#__PURE__*/_jsx(MenuDivider, _objectSpread({}, restProps), mergedKey);
      }
      return /*#__PURE__*/_jsx(MenuItem, _objectSpread(_objectSpread({}, restProps), {}, {
        children: label
      }), mergedKey);
    }
    return null;
  }).filter(function (opt) {
    return opt;
  });
}

// FIXME: Move logic here in v5
/**
 * We simply convert `items` to ReactNode for reuse origin component logic. But we need move all the
 * logic from component into this hooks when in v5
 */
export default function useItems(items) {
  return React.useMemo(function () {
    if (!items) {
      return items;
    }
    return convertItemsToNodes(items);
  }, [items]);
}